"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_export_templates_service_client_js_1 = require("@synisys/idm-export-templates-service-client-js");
var material_1 = require("@angular/material");
var yes_no_popup_component_1 = require("./yes-no-popup/yes-no-popup.component");
var Observable_1 = require("rxjs/Observable");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var MultilingualEditorComponent = /** @class */ (function () {
    function MultilingualEditorComponent(_languageService, _dialog, currentLanguageProvider, _kbService) {
        var _this = this;
        this._languageService = _languageService;
        this._dialog = _dialog;
        this.currentLanguageProvider = currentLanguageProvider;
        this._kbService = _kbService;
        /**
         * Indicates mode of editor, it can be simple text editor or export editor
         */
        this.isSimpleEditorMode = false;
        /**
         * Indicates if editor is in the form and entity is present or is in export builder
         */
        this.isEntityContextAvailable = false;
        this.templateChange = new core_1.EventEmitter();
        this.selectedLanguages = [];
        this.nonInputLanguages = [];
        this._destroy$ = new Subject_1.Subject();
        this._inputLanguages = [];
        this._selectedNonInputLanguages = [];
        this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (language) { return _this.currentLanguage = language; });
    }
    Object.defineProperty(MultilingualEditorComponent.prototype, "selectedNonInputLanguages", {
        get: function () {
            return this._selectedNonInputLanguages;
        },
        set: function (value) {
            var _this = this;
            this._selectedNonInputLanguages = value;
            this.selectedLanguages = this._systemLanguages.filter(function (language) {
                return _this._selectedNonInputLanguages.find(function (l) { return l.getId() === language.getId(); })
                    || _this._inputLanguages.find(function (l) { return l.getId() === language.getId(); });
            });
            var map = new Map();
            this.selectedLanguages.forEach(function (language) {
                var htmlTemplate = _this.template.htmlTemplate.getValue(language.getId());
                if (htmlTemplate !== null && htmlTemplate !== undefined) {
                    map.set(language.getId(), htmlTemplate);
                }
            });
            this.template.htmlTemplate = new idm_crosscutting_concepts_frontend_1.MultilingualString(map);
        },
        enumerable: true,
        configurable: true
    });
    MultilingualEditorComponent.prototype.ngOnInit = function () {
        !this.isSimpleEditorMode && this.initMetaCategoryId();
        this.loadLanguages();
    };
    MultilingualEditorComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.unsubscribe();
    };
    MultilingualEditorComponent.prototype.setTemplate = function (templateValue, language) {
        this.template.htmlTemplate = new idm_crosscutting_concepts_frontend_1.MultilingualString(this.template.htmlTemplate.toMap().set(language.getId(), templateValue));
        this.templateChange.emit(this.template);
    };
    MultilingualEditorComponent.prototype.removeLanguage = function (language) {
        var _this = this;
        this._dialog.open(yes_no_popup_component_1.YesNoPopupComponent).beforeClose().pipe(operators_1.takeUntil(this._destroy$)).subscribe(function (ok) {
            if (ok) {
                _this.selectedLanguages = _this.selectedLanguages.filter(function (l) { return l !== language; });
                _this._selectedNonInputLanguages = _this._selectedNonInputLanguages.filter(function (l) { return l !== language; });
                _this.removeTemplate(language);
            }
        });
    };
    MultilingualEditorComponent.prototype.removeTemplate = function (language) {
        var templateMap = this.template.htmlTemplate.toMap();
        templateMap.delete(language.getId());
        this.template.htmlTemplate = new idm_crosscutting_concepts_frontend_1.MultilingualString(templateMap);
    };
    MultilingualEditorComponent.prototype.isLanguageInput = function (language) {
        return this._inputLanguages.includes(language);
    };
    MultilingualEditorComponent.prototype.loadLanguages = function () {
        var _this = this;
        Observable_1.Observable.zip(this._languageService.getAvailableLanguages(), this._languageService.getInputLanguages())
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (data) {
            _this._systemLanguages = data[0];
            _this._inputLanguages = data[1];
            _this._systemLanguages.forEach(function (language) {
                var value = _this.template.htmlTemplate.toMap().get(language.getId());
                var valueExist = !!value && value.trim() !== '';
                var isLanguageInput = _this.isLanguageInput(language);
                if (valueExist || isLanguageInput) {
                    _this.selectedLanguages.push(language);
                }
                if (!isLanguageInput && valueExist) {
                    _this._selectedNonInputLanguages.push(language);
                }
            });
            _this.nonInputLanguages = _this._systemLanguages.filter(function (item) { return _this._inputLanguages.indexOf(item) < 0; });
        });
    };
    MultilingualEditorComponent.prototype.initMetaCategoryId = function () {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(this._kbService);
        this._kbService.getAllMetaCategories().pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (metaCategories) {
            metaCategories.forEach(function (value) {
                if (value.getSystemName() === _this.template.categoryName) {
                    _this.metaCategoryId = value.getMetaCategoryId();
                }
            });
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], MultilingualEditorComponent.prototype, "isSimpleEditorMode", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], MultilingualEditorComponent.prototype, "isEntityContextAvailable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_export_templates_service_client_js_1.Template)
    ], MultilingualEditorComponent.prototype, "template", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], MultilingualEditorComponent.prototype, "templateChange", void 0);
    MultilingualEditorComponent = __decorate([
        core_1.Component({
            selector: 'sis-multilingual-template-editor',
            template: require('./multilingual-editor.component.html'),
            styles: [require('./multilingual-editor.component.css')]
        }),
        __param(3, core_1.Optional()),
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.LanguageService,
            material_1.MatDialog,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_kb_service_client_js_1.KbService])
    ], MultilingualEditorComponent);
    return MultilingualEditorComponent;
}());
exports.MultilingualEditorComponent = MultilingualEditorComponent;
//# sourceMappingURL=multilingual-editor.component.js.map